import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {TimelineLite,Timeline,TimelineMax} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {bonusWheelEvents} from "./bonusWheelController";
import {ImmortalFruitsParsedGameData} from "../server/data/ImmortalFruitsParsedGameData";
import {IImortalFruitsParsedServerData} from "../server/data/IImortalFruitsParsedServerData";


export class ImmortalFruitsWinPresentation implements GameRoundPresentation {
    private _tl: TimelineLite;
    private maintlduration:number =0;
    private isAborted:boolean =false;
    constructor() {
        EventHandler.addEventListener(this, bonusWheelEvents.NOTIFY_WP_FINISH, (event: GameEvent) => this.getNotificationOfTimeLineFinish(event.params[0]));

    }
    /**
     * @inheritDoc
     * @param data
     */
    getAnimation(data: ImmortalFruitsParsedGameData): gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax | null {
        this._tl =new TimelineLite({onComplete:()=>{
            //console.log("onCompletion of WheelWIn")
            }});
         EventHandler.dispatchEvent(new GameEvent(bonusWheelEvents.HIGHLIGHT_ONABORT));

        this._tl.add(()=>{

        },0.2);
        this._tl.add(()=>{

        });
        return this._tl;
    }
    private getNotificationOfTimeLineFinish(duration:number){
        //console.log("finall getNotificationOfTimeLineFinish",duration);
        this.maintlduration = duration;

        this._tl.add(()=>{

        },duration);
    }
    public prepare(data: IImortalFruitsParsedServerData): void {

    }
    abort(isActive: boolean, data: ParsedServerData): Timeline | null {
        let tl =new TimelineLite();
        this.isAborted = true;
        //console.log("abortedWP");
        tl.add(()=>{
            //console.log("compPleted Aborted");
            EventHandler.dispatchEvent(new GameEvent(bonusWheelEvents.ABORT_ANIMATIONS));
        },this.maintlduration);
        return tl
    }
}